module.exports = __webpack_public_path__ + "static/media/departure_station_icon.96ca5b5c.svg";